import Vue from "vue";

import NotificationSettings from "./NotificationSettings.vue";

export function load() {
    const selector = "notification-settings";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(NotificationSettings, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
